export default function () {
  this.existsRegister('/v1/professional/steps/locks/status', (data, meta) => {
    if (!data.agendas) {
      this.statusAgenda = data.agendas
      this.show = true
    }

    this.statusAgenda = data.agendas
    this.show = false
  })
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/resources/mounted.js